import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Loader from '@/components/Loader';
import useOnlineStatus from '@/hooks/useOnlineStatus';
import { useSnackbar } from '@/hooks/useSnackbar';
import useStore from '@/store';

function ApiStatus() {
  const { showSnackbar } = useSnackbar();
  const isOnline = useOnlineStatus();
  const { t } = useTranslation('task');
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const { loaderCount } = useStore();

  const getSnackBarText = useCallback(() => {
    // if (isInternetIssue) {
    //   return `${t('somethingWentWrongTryAgain')}`;
    // }
    return `${t('checkInternetConnection')}`;
  }, [t]);

  useEffect(() => {
    if (!isOnline) {
      showSnackbar(getSnackBarText());
    }
  }, [isOnline, showSnackbar, getSnackBarText]);

  const isLoading = isFetching > 0 || isMutating > 0;

  if (loaderCount > 0) return <Loader className="h-[100vh] w-[100vw]" />;
  return isLoading && <Loader />;
}
export default ApiStatus;
